function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];

  if (null != t) {
    var e,
        n,
        i,
        u,
        a = [],
        f = !0,
        o = !1;

    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) {
        ;
      }
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }

    return a;
  }
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { Form as FinalForm, FormSpy } from 'react-final-form';
import { FormattedMessage } from 'react-intl';
import { DEFAULT_EVENT_TYPE, DEFAULT_ORDER_TYPE } from '../api';
import { DEFAULT_RESULTS_PER_PAGE } from '../config';
import { ClearButton, DateRangeGroup, GivenNameInput, SearchButton, SearchPlaceInput, SortBySelect, SortOrderSelect, SurnameInput } from '../form';
import { DEFAULT_RANGE, DEFAULT_YEAR_PLUS_MINUS } from '../form/DateRangeGroup';
import { prefillForm, setLiveFormData, submitForm, useFormContext } from '../state/form';
import { deepEqual } from '../utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function BlockForm(_ref) {
  var initialPartialData = _ref.initialPartialData,
      setInitialPartialData = _ref.setInitialPartialData,
      onClear = _ref.onClear,
      focused = _ref.focused;

  var _useFormContext = useFormContext(),
      formState = _useFormContext.state,
      dispatchForm = _useFormContext.dispatch;

  var submitFormDispatch = function submitFormDispatch(formData) {
    return dispatchForm(submitForm(formData));
  };

  var onSubmit = function onSubmit(data, e) {
    submitFormDispatch(data);
  };

  var prefillFormDispatch = function prefillFormDispatch(partialFormData) {
    return dispatchForm(prefillForm(partialFormData));
  };

  useEffect(function () {
    if (initialPartialData !== null) {
      prefillFormDispatch(initialPartialData);
      setInitialPartialData(null);
    }
  }, [initialPartialData]);

  var setLiveFormDataDispatch = function setLiveFormDataDispatch(values) {
    return dispatchForm(setLiveFormData(values));
  };

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      initialChange = _useState2[0],
      setInitialChange = _useState2[1];

  useEffect(function () {
    setInitialChange(true);
  }, []);

  var handleFormChange = function handleFormChange(state) {
    // Prevent a warning
    if (initialChange) {
      setInitialChange(true);
      setLiveFormDataDispatch(state.values);
    }
  };

  var initialValues = {
    surname: undefined,
    givenName: undefined,
    place: [],
    sortBy: DEFAULT_EVENT_TYPE,
    rangeType: DEFAULT_RANGE,
    yearPlusMinus: String(DEFAULT_YEAR_PLUS_MINUS),
    sortOrder: DEFAULT_ORDER_TYPE,
    resultsPerPage: DEFAULT_RESULTS_PER_PAGE
  };

  var renderForm = function renderForm(_ref2) {
    var handleSubmit = _ref2.handleSubmit,
        values = _ref2.values;
    var unsubmittable = !values.surname || !values.surname.trim();
    var modified = !deepEqual(values, initialValues, false);
    var isLoading = formState.loading;
    var resettable = modified || !!formState.data; // TODO

    return /*#__PURE__*/_jsxs(Form, {
      onSubmit: handleSubmit,
      children: [/*#__PURE__*/_jsx(FormSpy, {
        onChange: handleFormChange,
        subscription: {
          values: true
        }
      }), /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsx(Col, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            id: "form.description",
            values: {
              year: /*#__PURE__*/_jsx("strong", {
                children: "1970"
              })
            }
          })
        })
      }), /*#__PURE__*/_jsxs(Row, {
        className: "form-row",
        children: [/*#__PURE__*/_jsx(Col, {
          md: 3,
          children: /*#__PURE__*/_jsx(SurnameInput, {
            disabled: isLoading,
            focused: focused
          })
        }), /*#__PURE__*/_jsx(Col, {
          md: 3,
          children: /*#__PURE__*/_jsx(GivenNameInput, {
            disabled: isLoading
          })
        }), /*#__PURE__*/_jsx(Col, {
          md: 5,
          lg: 4,
          children: /*#__PURE__*/_jsx(SearchPlaceInput, {
            disabled: isLoading
          })
        }), /*#__PURE__*/_jsx(Col, {
          xs: {
            order: 2
          },
          md: {
            span: 1,
            order: 0
          },
          lg: 2,
          children: /*#__PURE__*/_jsx(SearchButton, {
            disabled: unsubmittable || isLoading,
            isLoading: isLoading
          })
        }), /*#__PURE__*/_jsx(Col, {
          md: 3,
          xl: {
            offset: 1,
            span: 2
          },
          children: /*#__PURE__*/_jsx(SortBySelect, {
            disabled: isLoading
          })
        }), /*#__PURE__*/_jsx(Col, {
          md: 5,
          lg: 4,
          children: /*#__PURE__*/_jsx(DateRangeGroup, {
            disabled: isLoading
          })
        }), /*#__PURE__*/_jsx(Col, {
          md: 3,
          xl: 2,
          children: /*#__PURE__*/_jsx(SortOrderSelect, {
            disabled: isLoading
          })
        }), resettable && /*#__PURE__*/_jsx(Col, {
          xs: {
            order: 1
          },
          md: 1,
          lg: 2,
          xl: {
            offset: 1,
            span: 2
          },
          children: /*#__PURE__*/_jsx(ClearButton, {
            initialValues: initialValues,
            disabled: isLoading,
            onClick: onClear
          })
        })]
      })]
    });
  };

  return /*#__PURE__*/_jsx("div", {
    className: "block block-form",
    children: /*#__PURE__*/_jsx(FinalForm, {
      onSubmit: onSubmit,
      initialValues: formState.liveForm !== null ? formState.liveForm : initialPartialData !== null ? initialPartialData : initialValues,
      render: renderForm
    })
  });
}
BlockForm.propTypes = {
  initialPartialData: PropTypes.object,
  setInitialPartialData: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
  focused: PropTypes.bool.isRequired
};
BlockForm.defaultProps = {
  initialPartialData: null
};